// Dependencies
// -----------------------------------------------
import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { fetchWlsBookingCalendar } from '../../utils/wls-api-client';
import {
  isChangeoverBlocked,
  resolveChangeoverForDay
} from '../../utils/wls-availability-changeover';

// Components
// -----------------------------------------------
import WidgetDatePickerContainer from './widget-date-picker-container';

// -----------------------------------------------
// COMPONENT->WIDGET-DATE-PICKER -----------------
// -----------------------------------------------
export default class WidgetDatePicker extends React.Component {

  // Constructor
  // ---------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      bookingCalendar: this.props.bookingCalendar || {},
      focusedInput: null
    };
  }

  // On Focus Change
  // ---------------------------------------------
  onFocusChange = focusedInput => {
    this.setState({ focusedInput });
    if (typeof this.props.onFocusChange === 'function') {
      this.props.onFocusChange(focusedInput);
    }
  };

  // Changeover For Day
  // ---------------------------------------------
  changeoverForDay = day =>
    resolveChangeoverForDay(
      this.props.defaultAvailability,
      this.state.bookingCalendar,
      day
    ).changeover;

  // Component Did Mount
  // ---------------------------------------------
  componentDidMount() {
    if (Object.keys(this.state.bookingCalendar).length > 0) return null;

    fetchWlsBookingCalendar(this.props.brand, this.props.unitID)
      .then(response => {
        this.setState({ bookingCalendar: response.data.booking_calendar });
      })
      .catch(error => { console.log(error); });
  }

  // Calendar Day Status
  // ---------------------------------------------
  calendarDayStatus = (day = moment()) => {
    const key = day.format('DD-MM-YYYY');
    const keyDate = this.state.bookingCalendar[key];
    let status;
    if (this.props.defaultAvailability) {
      status = resolveChangeoverForDay(
        this.props.defaultAvailability,
        this.state.bookingCalendar,
        day
      ).availability;
    }

    status = get(
      keyDate,
      'status',
      get(keyDate, 'availability', status || 'available')
    );

    if (
      this.props.initialStartDate &&
      this.props.initialEndDate &&
      (day.isSame(this.props.initialStartDate, 'day') ||
        day.isSame(this.props.initialEndDate, 'day'))
    ) {
      status = 'available';
    }

    return status;
  };

  // Is Day Blocked
  // ---------------------------------------------
  isDayBlocked = (day = moment()) => {
    const status = this.calendarDayStatus(day);

    let blocked =
      status === 'blocked' ||
      status === 'check_in_out' ||
      status === 'unavailable';

    if (!blocked) {
      blocked = isChangeoverBlocked(
        this.changeoverForDay(day),
        this.state.focusedInput
      );
    }

    if (
      this.props.initialStartDate &&
      this.props.initialEndDate &&
      day.isBetween(this.props.initialStartDate, this.props.initialEndDate)
    ) {
      blocked = false;
    }

    return blocked;
  };

  // Render
  // ---------------------------------------------
  render() {
    return (
      <WidgetDatePickerContainer
        {...this.props}
        onFocusChange={this.onFocusChange}
        // react-dates only recomputes blocked days when this prop changes identity
        isDayBlocked={day => this.isDayBlocked(day)}
        calendarDayStatus={this.calendarDayStatus}
        readOnly={this.props.readOnly}
        useDesignKit={this.props.useDesignKit}
      />
    );
  }
}
